import { AccordionDetails, AccordionSummary } from '@mui/material'
import ReactPlayer from 'react-player'
import { GiftCardRedeemNextStepsAccordion } from './styledComponents'
import TouchAppIcon from '@mui/icons-material/TouchApp'

export default function NextStepsVideoComponent({
  buttonText = 'Steps for redeeming your gift card',
  videoLink = 'https://youtu.be/ljBlaoPAj2A',
  buttonTextColor = '#d2d2d2',
}) {
  return (
    <GiftCardRedeemNextStepsAccordion elevation={0} defaultExpanded={false}>
      <AccordionSummary aria-controls="panel-content">
        <h5
          className="m-0"
          style={{
            textDecoration: 'underline',
            textAlign: 'center',
            color: buttonTextColor,
            fontSize: '16px',
          }}
        >
          {buttonText}
          <TouchAppIcon style={{ color: buttonTextColor , fontSize: '16px' }} />
        </h5>
      </AccordionSummary>
      <AccordionDetails>
        <div className="pb-3 d-flex justify-content-center align-items-center">
          <ReactPlayer url={videoLink} />
        </div>
      </AccordionDetails>
    </GiftCardRedeemNextStepsAccordion>
  )
}
